import { Typography } from '@mui/material';
import React from 'react';
import { useTheme } from 'styled-components';

export const TagButton = ({ text = '', style = {} }) => {
  const theme = useTheme();

  return (
    <Typography
      sx={{
        color: theme.palette.secondary.main,
        padding: '2px 10px',
        backgroundColor: `${theme.palette.customColors.darkGreen}`,
        width: 'fit-content',
        fontSize: theme.palette.textFontSize.heading3,
        fontWeight: '600',
        borderRadius: '4px',
        ...style
      }}
    >
      {text}
    </Typography>
  );
};
